import React from 'react';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { AppProviders } from './providers/AppProviders';

function App() {
  return (
    <React.StrictMode>
      <AppProviders />
    </React.StrictMode>
  );
}

export { App };
